import React from "react";
import { faBell } from "@fortawesome/free-solid-svg-icons"; // Import FontAwesome icon
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import ProfileCardBase from "./ProfileCardBase/ProfileCardBase";

const NotificationCard: React.FC = () => {
  const { currentUser } = useLoginContext();

  if (isCompanyUser(currentUser) || !currentUser) return null;

  return (
    <ProfileCardBase
      title="Notifikasjoner"
      actionText="Se notifikasjoner"
      actionLink="/student-profile/notifications/"
      icon={faBell} // Pass the FontAwesome icon directly
    >
      Her kan du se en oversikt over alle dine notifikasjoner.
    </ProfileCardBase>
  );
};

export default NotificationCard;
